<div
  mat-dialog-title
  appDraggableDialog
  draggableKey="map-tree"
  appResizableDialog
  resizableKey="map-tree"
  resizableTargetClass="q9-map-tree">
  <div>
    <span>{{ 'POPUPS.MAP_TREE' | translate }} {{ title | htmlEncoder: true }}</span>
    <div class="tree-progressbar">
      <mat-progress-bar
        [style.display]="processing ? 'block' : 'none'"
        [mode]="'indeterminate'"></mat-progress-bar>
    </div>
  </div>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="map-tree-content">
  <div class="map-tree" [style.display]="valid ? 'block' : 'none'">
    <tree-root #tree [nodes]="nodes" [options]="treeOpts" (updateData)="treeUpdate()">
      <ng-template #treeNodeWrapperTemplate let-node let-index="index">
        <div class="node-wrapper" [style.padding-left]="node.getNodePadding()">
          <q9-icon-button
            *ngIf="node.hasChildren"
            [icon]="node.isExpanded ? 'arrow_up' : 'arrow_right-icon'"
            (click)="node.toggleExpanded()"></q9-icon-button>
          <div
            class="node-content-wrapper"
            [class.node-content-wrapper-active]="node.isActive"
            [class.node-content-wrapper-focused]="node.isFocused"
            [class.node-content-wrapper-no-children]="!node.hasChildren"
            [treeAllowDrop]="node.allowDrop"
            [treeDrag]="node"
            [treeDragEnabled]="node.allowDrag()"
            (click)="node.mouseAction('click', $event)"
            (dblclick)="node.mouseAction('dblClick', $event)"
            (contextmenu)="node.mouseAction('contextMenu', $event)"
            (treeDrop)="node.onDrop($event)">
            <app-map-tree-node [node]="node.data"></app-map-tree-node>
          </div>
        </div>
      </ng-template>
    </tree-root>
  </div>

  <div *ngIf="!valid && !processing" class="map-tree-broken">
    <div class="map-tree-broken__content">
      <img [src]="noItemsImageUrl" alt="no_items" />
      <span>{{ 'POPUPS.MAP_TREE_BROKEN' | translate }}</span>
    </div>
  </div>
</mat-dialog-content>
